export const readFile = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = () => {
      const result = fr.result?.toString()
      if (!result) {
        reject()
        return
      }
      resolve(result)
    }
    fr.onerror = reject
    fr.readAsDataURL(blob)
  })
}
